/**
 * Product surface flags (CRA build-time).
 *
 * REACT_APP_MILAN_WORKSPACE_ENABLED
 *   "1" / unset → show end-to-end Milan campaigns (find creators, escrow, brand workspace, etc.)
 *   "0" / "false" / "off" → Performance Hub only (marketing + routes for campaigns hidden)
 *
 * Flip the env var and rebuild — no further frontend code changes needed.
 */
function envEnabled(raw, defaultOn = true) {
  const v = String(raw ?? '').trim().toLowerCase();
  if (!v) return defaultOn;
  if (['0', 'false', 'off', 'no'].includes(v)) return false;
  if (['1', 'true', 'on', 'yes'].includes(v)) return true;
  return defaultOn;
}

/** End-to-end Milan Workspace (campaigns, find creators, escrow UI). */
export const MILAN_WORKSPACE_ENABLED = envEnabled(
  process.env.REACT_APP_MILAN_WORKSPACE_ENABLED,
  true
);

/** Brand post-login / post-signup destination. */
export function getBrandAppPath() {
  return MILAN_WORKSPACE_ENABLED ? '/brand-dashboard' : '/performance';
}

/** Dashboard path for any authenticated user type. */
export function getPostAuthPath(userType) {
  if (userType === 'creator') return '/creator-dashboard';
  return getBrandAppPath();
}
